import {Outlet, createFileRoute} from "@tanstack/react-router";
import {ErrorComponent} from "./-errorComponent";
import {NotFoundComponent} from "./-notFoundComponent";
import {PendingComponent} from "./-pendingComponent";

export const Route = createFileRoute(
    "/_withAuthenticationStatus/_authenticated/_withProfileStatus/_profileCompleted/a/_adminScaffold/workspace-capabilities",
)({
    component: Outlet,
    errorComponent: ErrorComponent,
    pendingComponent: PendingComponent,
    notFoundComponent: NotFoundComponent,
});
